import React from "react";

// 다른 메뉴(실시간 관제/다시보기/장비)와 동일한 ◀이전 / X·Y / 다음▶ 스타일로 통일
export default function EventPagination({
  totalCount,
  currentPage,
  totalPages,
  pageSize,
  onChangePage,
}) {
  if (totalCount <= 0) return null;

  return (
    <div className="mt-4 flex flex-col gap-3 border-t border-gray-100 pt-3 dark:border-white/10 sm:flex-row sm:items-center sm:justify-between">
      <div className="text-sm text-gray-500 dark:text-gray-400">
        {(currentPage - 1) * pageSize + 1} -{" "}
        {Math.min(currentPage * pageSize, totalCount)} / {totalCount}
      </div>

      <div className="flex items-center justify-end gap-2">
        <button
          type="button"
          onClick={() => onChangePage(Math.max(1, currentPage - 1))}
          disabled={currentPage <= 1}
          className="rounded-lg bg-gray-100 px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-200 disabled:cursor-default disabled:opacity-40 dark:bg-white/10 dark:text-gray-200 dark:hover:bg-white/15"
        >
          ◀ 이전
        </button>

        <div className="min-w-[56px] text-center text-sm font-semibold text-gray-600 dark:text-gray-300">
          {currentPage} / {totalPages}
        </div>

        <button
          type="button"
          onClick={() => onChangePage(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage >= totalPages}
          className="rounded-lg bg-gray-100 px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-200 disabled:cursor-default disabled:opacity-40 dark:bg-white/10 dark:text-gray-200 dark:hover:bg-white/15"
        >
          다음 ▶
        </button>
      </div>
    </div>
  );
}
